<div class="container">
  <h1 class="header">
    <div class="title">
      <mat-icon class="warning" fontIcon="warning_amber"></mat-icon>
      一部ユーザーのZoom連携に失敗しました
    </div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="this.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div class="main">
    <p>
      以下のユーザーは何かしらの理由で、Zoom連携に失敗しました。Zoomの設定などをご確認の上、再度お試しください。
    </p>
    <div class="errors">
      <table mat-table [dataSource]="this.errors">
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>メールアドレス</th>
          <td mat-cell *matCellDef="let error">
            {{ error.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>名前</th>
          <td mat-cell *matCellDef="let error">
            {{ error.name }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="this.displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: this.displayedColumns"></tr>
      </table>
    </div>
    <div class="footer">
      <button rectangle variant="primary" (click)="this.close()">OK</button>
    </div>
  </div>
</div>
